<template>
  <div class="header" v-if="isNav">
    <div class="l-head">
      <h1 class="l-logo-img">
        <img
          @click="navigoToHome"
          style="width: 40px; margin-top: -4px; cursor: pointer"
          src="../../../static/logo-2.png"
          alt="logo"
        />
        <!-- <div class="l-head-line">|</div>
        <div>企业服务</div> -->
      </h1>
      <div class="l-head-list">
        <ul class="l-h-l-ul">
          <li
            :class="[`l-h-l-li`, enterpriseIndex == i ? `l-h-l-li-active` : ``]"
            v-for="(s, i) in enterprise"
            :key="i"
            @click="navigoTo(s, i, `enterpriseIndex`)"
          >
            {{ s.title }}
            <div class="l-sub" v-if="1 === i">
              <div
                :class="[
                  `l-sub-menu`,
                  enterpriseSubIndex == key ? `l-sub-menu-active` : ``,
                ]"
                v-for="(item, key) in s.list"
                :key="key"
                @click.stop="navigoTo(item, key, `enterpriseSubIndex`, !0)"
              >
                {{ item.title }}
              </div>
            </div>
          </li>
        </ul>
        <div>
          <!-- <button class="l-head-btn1" type="button">我要求职</button>
					<button class="l-head-btn" type="button">我要招聘</button> -->
        </div>
      </div>
    </div>
  </div>
  <div class="header-1" v-else>
    <div class="l-head">
      <h1 class="l-logo-img">
        <!-- <img
          class="l-logo"
          @click="navigoToHome"
          src="../../../static/l-logo.png"
          alt="logo"
        /> -->
        <img
          @click="navigoToHome"
          style="width: 40px; margin-top: -4px; cursor: pointer"
          src="../../../static/logo-2.png"
          alt="logo"
        />
        <div class="l-head-line">|</div>
        <div>关于播聘</div>
      </h1>
      <div class="l-head-list">
        <ul class="l-h-l-ul">
          <li
            :class="[`l-h-l-li`, companyIndex == i ? `l-h-l-li-active` : ``]"
            v-for="(s, i) in company"
            :key="i"
            @click="navigoTo(s, i, `companyIndex`)"
          >
            {{ s.title }}
          </li>
          <!-- 	<li class="l-h-l-li">公司简介</li>
					<li class="l-h-l-li l-h-l-li-active">播聘历程</li>
					<li class="l-h-l-li">联系播聘</li>
					<li class="l-h-l-li">常见问题</li> -->
        </ul>
        <!-- <button class="l-head-btn-app" type="button">播聘APP</button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isNav: {
      type: [Boolean],
    },
  },
  data() {
    return {
      company: [
        // {
        //   title: "公司简介",
        //   path: "/company-intr",
        //   list: []
        // },
        {
          title: "联系播聘",
          path: "/company-relation",
          list: [],
        },
        {
          title: "常见问题",
          path: "/company-issue",
          list: [],
        },
      ],
      companyIndex: 0,
      enterpriseIndex: 0,
      enterpriseSubIndex: 0,
      // 企业
      enterprise: [
        {
          title: "软件下载",
          path: "/pa/download",
          list: [],
        },
        {
          title: "服务介绍",
          path: "/enterprise-home",
          list: [],
        },
        {
          title: "业务类型",
          path: "/enterprise-server",
          list: [
            {
              title: "视频在线招聘服务",
              path: "/enterprise-server",
            },
            {
              title: "即时用工招聘服务",
              path: "/enterprise-server-one",
            },
            {
              title: "短工招聘服务",
              path: "/enterprise-server-two",
            },
            {
              title: "企业增值服务",
              path: "/enterprise-server-three",
            },
          ],
        },
        // {
        //   title: "关于播聘",
        //   path: "/company-intr",
        //   list: []
        // },

        {
          title: "客户案例",
          path: "/enterprise-case",
          list: [],
        },
      ],
    };
  },
  created() {
    this.companyIndex = this.enterpriseIndex = this.routerActive;
  },
  methods: {
    navigoTo(s, i, key, b) {
      if (b) {
        if (this.enterpriseIndex != 1) {
          this.enterpriseIndex = 1;
        }
      } else {
        if (this.enterpriseSubIndex != 0) {
          this.enterpriseSubIndex = 0;
        }
      }
      this[key] = i;
      this.$nav({ path: s.path }, this);
      // this.$router.push({path:s.path})
    },
    navigoToHome() {
      this.$nav({ path: `/home` }, this);
      // this.$router.push({path:`/home`})
    },
    router() {
      let key = 0;
      let path = this.$route.path;
      let list = this[this.isNav ? `enterprise` : `company`];
      let bool = false;
      let _this = this;
      for (let i = 0, len = list.length; i < len; ++i) {
        let e = list[i];
        for (let k = 0, len = e.list.length; k < len; ++k) {
          let s = e.list[k];
          if (s.path === path) {
            _this.enterpriseSubIndex = k;
            bool = true;
            break;
          }
        }
        if (e.path === path || bool) {
          key = i;
          break;
        }
      }
      return key;
    },
  },
  watch: {
    $route() {
      this.companyIndex = this.enterpriseIndex = this.router();
    },
  },
  computed: {
    routerActive() {
      return this.router();
    },
  },
};
</script>

<style scoped="scoped">
@import url("./header.css");
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue